import UniDataTableRow from '@/common/classes/UniDataTableRow'
import { PLATFORM_SCRIPT_CONSOLE_PREAMBLE } from '@/common/utils/scriptConsole'

export const CLIENT_IMPORT_RUNTIME_WINDOW_KEYS = [
  'en',
  'data',
  'selected',
  'text',
  'UniDataTools',
  'UniData',
  'UniDataTable',
  'UniDataTableFields',
  'Packages',
  'SwingTreeTable',
  'java',
  'Messages',
  'ProgressBar',
  'convert',
  '$',
  'importer',
  'setTimeoutAsync',
  'asyncLoop',
  'process',
  'isInstanceOf',
  'javaLength',
] as const

/** Swing import-class: ru.esoft.Common.UniData.UniDataTableFields → UniDataTableRow. */
export function assignClientImportWindowGlobals(target: Window & typeof globalThis): void {
  ;(target as any).UniDataTableFields = UniDataTableRow
}

export const buildRuntimeGlobals = (
  keys: readonly string[] = CLIENT_IMPORT_RUNTIME_WINDOW_KEYS,
): string =>
  `${PLATFORM_SCRIPT_CONSOLE_PREAMBLE}${keys.map((key) => `var ${key} = window.${key};`).join('\n')}\n`
